"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LegalTypes = exports.PlanType = void 0;
var PlanType;
(function (PlanType) {
    PlanType["DTVNOW"] = "dtvnow";
    PlanType["WIRELESS"] = "wireless";
    PlanType["DTVS"] = "dtvs";
    PlanType["IPTV"] = "iptv";
    PlanType["WIRELESS_CRP"] = "wirelessCRP";
    PlanType["BROADBAND"] = "broadband";
    PlanType["WIRELESS_PREPAID"] = "PREPAID";
    PlanType["ACCESSORIES"] = "accessories";
    PlanType["HBOMAX"] = "hbomax";
    PlanType["BUSINESS_TOOLS"] = "business";
})(PlanType = exports.PlanType || (exports.PlanType = {}));
var LegalTypes;
(function (LegalTypes) {
    LegalTypes["DUEONFIRSTBILL"] = "duefirstbill";
    LegalTypes["DUEONMOTHLY"] = "duemonthly";
    LegalTypes["DUEONTODAY"] = "duetoday";
})(LegalTypes = exports.LegalTypes || (exports.LegalTypes = {}));
//# sourceMappingURL=CartViewPanelProps.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/cart-ui/components/panels/CartViewPanel/CartViewPanelProps.js
// module id = 96
// module chunks = 8